<template>
    <b-modal
        id="assignment-show-deadline-detail-modal"
        :title="$t('assignment.deadline_overview')"
        modal-class="apprentice-default-modal"
        ok-only
        :ok-title="$t('common.close')">
        <div
            v-if="allDeadlines.length"
            :class="$t('assignment.deadlines')">
            <b-media
                class="deadline-main-assignment-media"
                v-if="allDeadlines.length">
                <template #aside>
                    <i class="fad fa-alarm-exclamation icon"></i>
                </template>

                <div class="deadline-main-assignment-title">
                    <h5 class="title">
                        {{
                            allDeadlines[0].type === 'assignment'
                                ? $t('assignment.assignment')
                                : $t('assignment.sub_assignment')
                        }}
                        {{ allDeadlines[0].name }}
                    </h5>
                </div>

                <div class="deadline-main-assignment-content">
                    <div
                        class="date"
                        :class="
                            parseInt(moment(allDeadlines[0].deadline).diff(moment(), 'days')) >= 0
                                ? 'text-primary'
                                : 'text-danger'
                        ">
                        {{ getDeadlineDateText(allDeadlines[0].deadline) }}
                    </div>
                </div>

                <b-media
                    class="deadline-sub-assignment-media"
                    v-for="deadline in allDeadlines.slice(1)"
                    :key="deadline.id">
                    <template #aside>
                        <i class="fad fa-alarm-exclamation icon"></i>
                    </template>

                    <div class="deadline-main-assignment-title">
                        <h5 class="title">
                            {{
                                deadline.type === 'assignment'
                                    ? $t('assignment.assignment')
                                    : $t('assignment.sub_assignment')
                            }}
                            {{ deadline.name }}
                        </h5>
                    </div>

                    <div class="deadline-sub-assignment-content">
                        <div
                            class="date"
                            :class="
                                parseInt(moment(deadline.deadline).diff(moment(), 'days')) >= 0
                                    ? 'text-primary'
                                    : 'text-danger'
                            ">
                            {{ getDeadlineDateText(deadline.deadline) }}
                        </div>
                    </div>
                </b-media>
            </b-media>
        </div>
    </b-modal>
</template>

<script>
import moment from 'moment';

export default {
    name: 'design-2021-assignment-show-deadline-details-modal-component',
    props: {
        deadlines: Array,
    },
    computed: {
        allDeadlines() {
            return this.deadlines.slice().sort((a, b) => (a.order > b.order ? 1 : -1));
        },
    },
    methods: {
        getDeadlineDateText(deadlineDate) {
            if (parseInt(moment(deadlineDate).diff(moment(), 'days')) >= 0) {
                return this.$options.filters.date_time_om(deadlineDate);
            } else {
                `${this.$t('assignment.return_expired_on')} ${this.$options.filters.date_time_om(deadlineDate)}`;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.deadline-main-assignment-media,
.deadline-sub-assignment-media {
    .icon {
        font-size: 2rem;
        color: $danger;
    }

    .title {
        font-size: 1.125rem;
        font-weight: $font-weight-medium;
        margin-bottom: 0;
    }

    .date {
        font-size: $base-font-size;
        font-weight: $font-weight-bold;
    }
}

.deadline-sub-assignment-media {
    margin-top: map-get($grid-gutter-spacing, 'fifteen');
}
</style>
